import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import React, { useState } from 'react';
import Title from '../ResumenHCE/Title';
import { GenericoEvoluciones } from './GenericoEvoluciones';
import {
  TraerEvolucionesAfiliado,
  pasarErrorDiagnostico,
} from '../../../../../actions/hce/hceActions';
import { useDispatch } from 'react-redux';
import { DeleteOutlineSharp, ImportExportSharp } from '@material-ui/icons';
import { GenericoCambioEstado } from './GenericoCambioEstado';
import { HCE_ESTADOS_PROBLEMAS } from '../../../../../utils/constants';

const optionsfecha = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const CardAntecedentesPersonales = (props) => {
  const { problemasAfiliiado, hce, disabled } = props;
  const dispatch = useDispatch();
  const [editProblema, setEditProblema] = useState(false);
  const [editEstado, setEditEstado] = useState(false);
  const [openModalCambioEstado, setOpenModalCambioEstado] = useState(false);
  const [openModalDiagnostico, setOpenModalDiagnostico] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [tituloModal, setTituloModal] = useState('');

  const handleDelete = () => {
    setConfirmOpen(!confirmOpen);
  };

  return (
    <React.Fragment>
      {openModalDiagnostico && (
        <GenericoEvoluciones
          open={openModalDiagnostico}
          close={() => {
            setOpenModalDiagnostico(false);
          }}
          titulo={tituloModal}
          hce={hce}
          diagnostico={editProblema}
          disabled={props.disabled}
        />
      )}
      {openModalCambioEstado && (
        <GenericoCambioEstado
          open={openModalCambioEstado}
          close={() => {
            setOpenModalCambioEstado(false);
          }}
          titulo={tituloModal}
          hce={hce}
          diagnostico={editEstado}
          disabled={props.disabled}
        />
      )}
      <Title>Antecedentes Personales</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Problema</TableCell>
            <TableCell>Doctor</TableCell>
            <TableCell>FechaAlta</TableCell>
            <TableCell>Cambiar Estado</TableCell>
            <TableCell>Pasar error</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.isArray(problemasAfiliiado) &&
            problemasAfiliiado.length > 0 ? (
            problemasAfiliiado.map((infoAfiliado) =>
              infoAfiliado.idEstadoProblema ===
                HCE_ESTADOS_PROBLEMAS.ANTECEDENTES_PERSONALES &&
                infoAfiliado.fechaPasadoAError == null ? (
                <TableRow key={infoAfiliado.id}>
                  <TableCell>
                    <span
                      onClick={() => {
                        setTituloModal('Evoluciones Paciente');
                        setEditProblema(infoAfiliado);
                        setOpenModalDiagnostico(true);
                        dispatch(TraerEvolucionesAfiliado(infoAfiliado.id));
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      {infoAfiliado.problema}
                    </span>
                  </TableCell>
                  <TableCell>{infoAfiliado.descripcionEfector}</TableCell>
                  <TableCell>
                    {new Date(infoAfiliado.fechaAlta).toLocaleString(
                      'es',
                      optionsfecha,
                    )}
                  </TableCell>
                  <TableCell>
                    {' '}
                    <div style={{ textAlign: 'center', margin: '1rem 0' }}>
                      {!disabled &&
                        <Button
                          disabled={disabled}
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            setTituloModal('Cambiar Estado Problema');
                            setEditEstado(infoAfiliado);
                            setOpenModalCambioEstado(true);
                          }}
                        >
                          <ImportExportSharp />
                        </Button>
                      }
                    </div>

                    <Dialog open={confirmOpen} onClose={handleDelete}>
                      <DialogTitle>Mensaje</DialogTitle>
                      <DialogContent>
                        <Typography>
                          ¿Estás seguro de que deseas pasar a error el
                          problema?
                        </Typography>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          disabled={disabled}
                          variant="contained"
                          color="secondary"
                          onClick={() => {
                            const datos = {
                              id: infoAfiliado.id,
                              idEfectorRedPasadoAError:
                                infoAfiliado.idEfectorRed,
                              idEfectorRed: infoAfiliado.idEfectorRed,
                            };
                            dispatch(
                              pasarErrorDiagnostico(datos, hce.idAfiliado, hce.idAfiliadoExterno),
                            );
                            setConfirmOpen(false);
                          }}
                        >
                          Sí
                        </Button>
                        <Button
                          disabled={disabled}
                          variant="contained"
                          color="primary"
                          onClick={handleDelete}
                        >
                          No
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </TableCell>
                  <TableCell>
                    {' '}
                    <div style={{ textAlign: 'center', margin: '1rem 0' }}>
                      <Button
                        disabled={disabled}
                        variant="contained"
                        color="primary"
                        onClick={handleDelete}
                      >
                        <DeleteOutlineSharp />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ) : null,
            )
          ) : (
            <Typography style={{ fontStyle: 'italic', fontSize: '1.1rem' }}>
              No hay datos
            </Typography>
          )}
        </TableBody>
      </Table>
    </React.Fragment>
  );
};
